export type EventName = string;

export type ExtraData = {
    [key: string]: any;
};

export abstract class BaseEventTrackerWrapper {
    public abstract init(): void;
    public abstract tag(event: EventName, extraData?: ExtraData): void;
}
